import styled from "styled-components";

let S = {};

S.CartContainer = styled.div`
	text-align: right;
	padding-bottom: 0;

	& > button {
		display: inline-block;
		border: none;
		border-radius: 0;
		padding: 0;
		margin: 0;
		text-decoration: none;
		background: transparent;
		font-family: inherit;
		font-size: 1rem;
		color: ${(props) =>
			props["data-brand"] === "marisella"
				? "var(--primary)"
				: "var(--secondary)"};
		cursor: pointer;
		appearance: none;
		-moz-appearance: none;
		outline: none;

		&:hover {
			color: var(--primary);
		}

		& > div {
			display: flex;
			align-items: center;

			& > span {
				padding-top: 2px;
				padding-left: 7.5px;
			}
		}
	}
`;

S.BtnsGrid = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
	grid-gap: 15px;
	margin-bottom: 15px;

	& > button {
		display: inline-block;
		border: none;
		border: 1px solid var(--primary);
		border-radius: 4px;
		padding: 5.5px 5px 4px 5px;
		margin: 0;
		text-decoration: none;
		background: transparent;
		background-color: #fff;
		font-family: inherit;
		font-size: 1.1rem;
		cursor: pointer;
		appearance: none;
		-moz-appearance: none;
		outline: none;
		transition: all 0.3s;

		&:hover,
		&.selected {
			background-color: var(--primary);
			color: #fff;
		}
	}
`;

export default S;
